export default [
    {
        path: '/pages/dev/transactionLogManage',
        name: '/pages/dev/transactionLogManage',
        meta: { title: '交互日志' },
        component: () => import('@/views/dev/transactionLogManage.vue')
    },
    {
        path: '/pages/dev/serviceRegisterManage',
        name: '/pages/dev/serviceRegisterManage',
        meta: { title: '服务注册' },
        component: () => import('@/views/dev/serviceRegisterManage.vue')
    },
    {
        path: '/pages/dev/sysDocumentManage',
        name: '/pages/dev/sysDocumentManage',
        component: () => import('@/views/dev/sysDocumentManage.vue')
    },
    {
        path: '/pages/dev/serviceManage',
        name: '/pages/dev/serviceManage',
        meta: { title: '服务信息' },
        component: () => import('@/views/dev/serviceManage.vue')
    },
    {
        path: '/pages/dev/serviceProvideManage',
        name: '/pages/dev/serviceProvideManage',
        meta: { title: '服务提供' },
        component: () => import('@/views/dev/serviceProvideManage.vue')
    },
    {
        path: '/pages/dev/serviceBinding',
        name: '/pages/dev/serviceBinding',
        meta: { title: '服务绑定' },
        component: () => import('@/views/dev/serviceBinding.vue')
    },
    {
        path: '/pages/dev/serviceImplManage',
        name: '/pages/dev/serviceImplManage',
        meta: { title: '服务实现' },
        component: () => import('@/views/dev/serviceImplManage.vue')
    },
    {
        path: '/pages/dev/menuManage',
        name: '/pages/dev/menuManage',
        meta: { title: '菜单维护' },
        component: () => import('@/views/dev/menuManage.vue')
    },
    {
        path: '/pages/dev/reportCustomComponentFooterManage',
        name: '/pages/dev/reportCustomComponentFooterManage',
        component: () => import('@/views/dev/reportCustomComponentFooterManage.vue')
    },
    {
        path: '/pages/dev/reportCustomComponentManage',
        name: '/pages/dev/reportCustomComponentManage',
        meta: { title: '报表组件' },
        component: () => import('@/views/dev/reportCustomComponentManage.vue')
    },
    {
        path: '/pages/dev/reportCustomComponentRelManage',
        name: '/pages/dev/reportCustomComponentRelManage',
        component: () => import('@/views/dev/reportCustomComponentRelManage.vue')
    },
    {
        path: '/pages/dev/reportCustomGroupManage',
        name: '/pages/dev/reportCustomGroupManage',
        meta: { title: '报表组' },
        component: () => import('@/views/dev/reportCustomGroupManage.vue')
    },
    {
        path: '/pages/dev/reportCustomManage',
        name: '/pages/dev/reportCustomManage',
        meta: { title: '报表信息' },
        component: () => import('@/views/dev/reportCustomManage.vue')
    },
    {
        path: '/pages/dev/jobManage',
        name: '/pages/dev/jobManage',
        meta: { title: '定时任务' },
        component: () => import('@/views/dev/jobManage.vue')
    },
    {
        path: '/pages/dev/listDemo',
        name: '/pages/dev/listDemo',
        component: () => import('@/views/dev/listDemo.vue')
    },
    {
        path: '/pages/dev/mappingDomainManage',
        name: '/pages/dev/mappingDomainManage',
        meta: { title: '配置项' },
        component: () => import('@/views/dev/mappingDomainManage.vue')
    },
    {
        path: '/pages/dev/mappingManage',
        name: '/pages/dev/mappingManage',
        meta: { title: '配置中心' },
        component: () => import('@/views/dev/mappingManage.vue')
    },
    {
        path: '/pages/dev/menuCatalogManage',
        name: '/pages/dev/menuCatalogManage',
        meta: { title: '菜单目录' },
        component: () => import('@/views/dev/menuCatalogManage.vue')
    },
    {
        path: '/pages/dev/menuGroupCatalogManage',
        name: '/pages/dev/menuGroupCatalogManage',
        component: () => import('@/views/dev/menuGroupCatalogManage.vue')
    },
    {
        path: '/pages/dev/menuGroupManage',
        name: '/pages/dev/menuGroupManage',
        meta: { title: '菜单组' },
        component: () => import('@/views/dev/menuGroupManage.vue')
    },
    {
        path: '/pages/dev/componentConditionManage',
        name: '/pages/dev/componentConditionManage',
        component: () => import('@/views/dev/componentConditionManage.vue')
    },
    {
        path: '/pages/dev/configMenu',
        name: '/pages/dev/configMenu',
        meta: { title: '配置菜单' },
        component: () => import('@/views/dev/configMenu.vue')
    },
    {
        path: '/pages/dev/devServiceProvide',
        name: '/pages/dev/devServiceProvide',
        meta: { title: '开发服务' },
        component: () => import('@/views/dev/devServiceProvide.vue')
    },
    {
        path: '/pages/dev/dictManage',
        name: '/pages/dev/dictManage',
        meta: { title: '字典' },
        component: () => import('@/views/dev/dictManage.vue')
    },
    {
        path: '/pages/dev/InitializeCommunityManage',
        name: '/pages/dev/InitializeCommunityManage',
        component: () => import('@/views/dev/InitializeCommunityManage.vue')
    },
    {
        path: '/pages/dev/businessDatabusManage',
        name: '/pages/dev/businessDatabusManage',
        meta: { title: 'Databus' },
        component: () => import('@/views/dev/businessDatabusManage.vue')
    },
    {
        path: '/pages/dev/businessTableHisManage',
        name: '/pages/dev/businessTableHisManage',
        meta: { title: '业务轨迹' },
        component: () => import('@/views/dev/businessTableHisManage.vue')
    },
    {
        path: '/pages/dev/cacheManage',
        name: '/pages/dev/cacheManage',
        meta: { title: '刷新缓存' },
        component: () => import('@/views/dev/cacheManage.vue')
    },
    {
        path: '/pages/dev/appManage',
        name: '/pages/dev/appManage',
        meta: { title: '应用信息' },
        component: () => import('@/views/dev/appManage.vue')
    },
    {
        path: '/pages/dev/attrSpecManage',
        name: '/pages/dev/attrSpecManage',
        meta: { title: '属性' },
        component: () => import('@/views/dev/attrSpecManage.vue')
    },
    {
        path: '/pages/dev/attrValueManage',
        name: '/pages/dev/attrValueManage',
        meta: { title: '属性值' },
        component: () => import('@/views/dev/attrValueManage.vue')
    },
    {
        path: '/pages/dev/basePrivilegeManage',
        name: '/pages/dev/basePrivilegeManage',
        meta: { title: '基础权限' },
        component: () => import('@/views/dev/basePrivilegeManage.vue')
    },
    {
        path: '/pages/dev/privilege',
        name: '/pages/dev/privilege',
        component: () => import('@/views/dev/privilege.vue')
    },
    {
        path: '/pages/dev/addRoute',
        name: '/pages/dev/addRoute',
        component: () => import('@/views/dev/addRoute.vue')
    }
] 